// extracted by mini-css-extract-plugin
export default {"wrapper":"BorderTopContainer_wrapper__nfeea"};